<template>
	<div>
		<label>* {{ _traducao('global', 'semana') }}:</label>
		<v-select type="number" :options="listaSemanas" label="semana" v-model="form.semana" class="form-control"></v-select>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	data() {
		return {
			listaSemanas: []
		}
	},
	created() {
		this.gerarSemanas()
	},
	methods: {
		gerarSemanas() {
			for (let i = 2; i < 54; i++) {
				const semanaDataInicio = window
					.moment()
					.week(i - 1)
					.startOf('isoWeek')
					.format('DD/MM/YYYY')
				const semanaDataFim = window.moment().week(i).format('DD/MM/YYYY')
				const semana = window.moment(semanaDataInicio, 'DD/MM/YYYY').week()
				const obj = {
					id: semana,
					semana: `${this._traducao('global', 'semana')}: ${semana} - ${semanaDataInicio} - ${semanaDataFim}`
				}
				this.listaSemanas.push(Object.assign({}, obj))
			}
		}
	}
}
</script>